import { el } from '../core/dom.js';

/** @param {{ title: string, body?: string, action?: Node }} opts */
export function empty(opts) {
  return el('div', { class: 'empty' },
    el('p', { class: 'kicker' }, 'Nothing here'),
    el('h2', { class: 'empty-title' }, opts.title),
    opts.body ? el('p', { class: 'empty-body' }, opts.body) : null,
    opts.action || null);
}
